export const announcement = {
  noticeType: [
    {
      label: '更新日志',
      value: 1
    }, {
      label: '重要通知',
      value: 2
    }
  ],
  logInRemind: [
    {
      label: '普通提醒',
      value: 0
    }, {
      label: '弹窗提醒',
      value: 1
    }
  ],
  assignGrouping: [
    {
      label: '全部用户',
      value: 0
    }, {
      label: '仅已认证业务员',
      value: 1
    }, {
      label: '仅未认证人员',
      value: 2
    }
    // , {
    //   label: '指定人员',
    //   value: 3
    // }, {
    //   label: '指定会员等级',
    //   value: 4
    // }, {
    //   label: '指定组织',
    //   value: 5
    // }
  ]
}

export default {
  announcement
}



// WEBPACK FOOTER //
// ./src/data/announcement.js